import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function RegisterPickup() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    role: 'pickup',
    phone: '',
    location: {
      address: '',
      suburb: '',
      state: '',
      postcode: ''
    },
    pickupSettings: {
      maxDeliveryDistanceKm: 30,
      vehicleType: 'car'
    }
  });
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name.includes('.')) {
      const [parent, child] = name.split('.');
      setFormData(prev => ({
        ...prev,
        [parent]: {
          ...prev[parent],
          [child]: value
        }
      }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const success = await register(formData);
    setLoading(false);
    if (success) {
      navigate('/pickup-dashboard');
    }
  };

  return (
    <div className="max-w-2xl mx-auto">
      <div className="bg-white p-8 rounded-lg shadow-md">
        <h1 className="text-2xl font-bold mb-6">Become a Pickup Partner</h1>
        <p className="text-gray-600 mb-6">Earn rewards by delivering fresh produce from local farms and hubs.</p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-gray-700 mb-2">Full Name *</label>
            <input type="text" name="name" value={formData.name} onChange={handleChange} className="w-full border rounded-md px-3 py-2" required />
          </div>
          <div>
            <label className="block text-gray-700 mb-2">Email *</label>
            <input type="email" name="email" value={formData.email} onChange={handleChange} className="w-full border rounded-md px-3 py-2" required />
          </div>
          <div>
            <label className="block text-gray-700 mb-2">Password *</label>
            <input type="password" name="password" value={formData.password} onChange={handleChange} className="w-full border rounded-md px-3 py-2" required />
          </div>
          <div>
            <label className="block text-gray-700 mb-2">Phone (optional)</label>
            <input type="tel" name="phone" value={formData.phone} onChange={handleChange} className="w-full border rounded-md px-3 py-2" />
          </div>

          <div className="border-t pt-4 mt-4">
            <h3 className="font-semibold mb-3">Your Location (for deliveries)</h3>
            <div className="space-y-3">
              <input type="text" name="location.address" placeholder="Street Address" value={formData.location.address} onChange={handleChange} className="w-full border rounded-md px-3 py-2" required />
              <div className="grid grid-cols-2 gap-4">
                <input type="text" name="location.suburb" placeholder="Suburb" value={formData.location.suburb} onChange={handleChange} className="w-full border rounded-md px-3 py-2" required />
                <input type="text" name="location.state" placeholder="State" value={formData.location.state} onChange={handleChange} className="w-full border rounded-md px-3 py-2" required />
                <input type="text" name="location.postcode" placeholder="Postcode" value={formData.location.postcode} onChange={handleChange} className="w-full border rounded-md px-3 py-2" required />
              </div>
            </div>
          </div>

          <div className="border-t pt-4 mt-4">
            <h3 className="font-semibold mb-3">Delivery Preferences</h3>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-gray-700 mb-2">Max Delivery Distance (km)</label>
                <input type="number" name="pickupSettings.maxDeliveryDistanceKm" value={formData.pickupSettings.maxDeliveryDistanceKm} onChange={handleChange} className="w-full border rounded-md px-3 py-2" />
              </div>
              <div>
                <label className="block text-gray-700 mb-2">Vehicle Type</label>
                <select name="pickupSettings.vehicleType" value={formData.pickupSettings.vehicleType} onChange={handleChange} className="w-full border rounded-md px-3 py-2">
                  <option value="car">Car</option>
                  <option value="bike">Bike</option>
                  <option value="walking">Walking</option>
                </select>
              </div>
            </div>
          </div>

          <button type="submit" disabled={loading} className="w-full bg-green-600 text-white py-2 rounded-md hover:bg-green-700 transition disabled:bg-gray-400">
            {loading ? 'Registering...' : 'Register as Pickup Partner'}
          </button>
        </form>

        <p className="mt-4 text-center text-gray-600">
          Already have an account? <Link to="/login" className="text-green-600 hover:underline">Login</Link>
        </p>
      </div>
    </div>
  );
}

